'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'citrus-slice';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e2f5';
var svgPathData = 'M391.7 391.4c-96.8 96.8-253.5 96.6-350.4-.3L7.4 425c115.6 115.6 302.6 116 418.3 .3S540.9 122.6 425.3 7L391.4 41c96.9 96.9 97.1 253.6 .3 350.4zM176.3 428.3l0-174.3c-7.1-1.8-13.7-4.9-19.7-8.8L48.3 353.5 63.6 368.7c32 32 71.4 51.8 112.7 59.5zm69.1-272c4 5.9 7 12.6 8.8 19.7l174.3 0c-7.7-41.2-27.4-80.5-59.2-112.4L353.8 48 245.5 156.3zm8.8 51.7c-1.5 5.9-3.8 11.4-6.8 16.5L380 357c36.8-42.6 54.2-96.1 52.2-149l-177.9 0zm-29.5 39.1c-5.1 3-10.6 5.3-16.5 6.8l0 177.9c52.9 2 106.4-15.5 149-52.2L224.8 247.1z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCitrusSlice = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;